/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ meeting: NonNullable<unknown> }} Chat_Line_Meeting_PrepInputs */



/**
* | output |
* | --- |
* | "Preparation · {meeting}" |
*
* @param {Chat_Line_Meeting_PrepInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const chat_line_meeting_prep = /** @type {((inputs: Chat_Line_Meeting_PrepInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Line_Meeting_PrepInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ (`Voorbereiding · ${i?.meeting}`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`Préparation · ${i?.meeting}`)
	return /** @type {LocalizedString} */ (`Preparation · ${i?.meeting}`)
});